import { apiRequest } from './api';

/**
 * Sprite submission API.
 *
 * Thin wrappers over `apiRequest` so components never assemble URLs or auth
 * headers themselves.
 *
 * Every capability reported here is ADVISORY. The client uses it to decide
 * what to render; the server decides what is allowed. `canSubmit` being true
 * does not make a submission succeed, and hiding a button does not protect
 * anything — see server/middleware/spriteAccess.js.
 */

export const getSettings = (token) => apiRequest('/api/sprites/settings', { token });

export const setSubmissionsOpen = (token, spriteSubmissionsOpen) => apiRequest(
  '/api/sprites/settings',
  { method: 'PUT', token, body: { spriteSubmissionsOpen } },
);

export const submitSprite = (token, { png, note, targetSheet = 'hero' }) => apiRequest(
  '/api/sprites/submissions',
  { method: 'POST', token, body: { png, note, targetSheet } },
);

export const listSubmissions = (token, status) => apiRequest(
  `/api/sprites/submissions${status ? `?status=${status}` : ''}`,
  { token },
);

export const getSubmission = (token, id) => apiRequest(`/api/sprites/submissions/${id}`, { token });

export const approveSubmission = (token, id, reviewNote = '') => apiRequest(
  `/api/sprites/submissions/${id}/approve`,
  { method: 'POST', token, body: { reviewNote } },
);

export const rejectSubmission = (token, id, reviewNote = '') => apiRequest(
  `/api/sprites/submissions/${id}/reject`,
  { method: 'POST', token, body: { reviewNote } },
);
